import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
// auth
import { AuthGuard, RoleBasedGuard } from "src/auth/guard";
// layouts
import DashboardLayout from "src/layouts/dashboard";
// components
import { LoadingScreen } from "src/components/loading-screen";
//
import { ENTERPRISE_ROLES } from "src/core/lib/constants";

//
const IndexPage = lazy(() => import("src/pages/dashboard/app"));
// USER
const EnterpriseGrid = lazy(() => import("src/pages/management/enterprise/enterprise-grid"));
const EnterpriseForm = lazy(() => import("src/pages/management/enterprise/enterprise-form"));
const GptConfigurationForm = lazy(() => import("src/pages/management/gpt/configuration-form"));
const LegacyMigrationLinkedRegister = lazy(() =>
  import("src/pages/management/legacy-migration/linked-register")
);

export const managementRoutes = [
  {
    path: "management",
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: "enterprise",
        children: [
          {
            element: (
              <RoleBasedGuard
                permissionBased={false}
                permissions={[ENTERPRISE_ROLES.admin, ENTERPRISE_ROLES.viewer]}
              >
                <EnterpriseGrid />
              </RoleBasedGuard>
            ),
            index: true,
          },
          {
            path: "grid",
            element: (
              <RoleBasedGuard
                permissionBased={false}
                permissions={[ENTERPRISE_ROLES.admin, ENTERPRISE_ROLES.viewer]}
              >
                <EnterpriseGrid />
              </RoleBasedGuard>
            ),
          },
          {
            path: "form",
            element: (
              <RoleBasedGuard
                permissionBased={false}
                permissions={[ENTERPRISE_ROLES.admin]}
              >
                <EnterpriseForm />
              </RoleBasedGuard>
            ),
          },
          {
            path: ":id/form",
            element: (
              <RoleBasedGuard
                permissionBased={false}
                permissions={[ENTERPRISE_ROLES.admin]}
              >
                <EnterpriseForm />
              </RoleBasedGuard>
            ),
          },
        ],
      },
      {
        path: "gpt",
        children: [
          {
            element: (
              <RoleBasedGuard
                permissionBased={false}
                permissions={[ENTERPRISE_ROLES.admin]}
              >
                <GptConfigurationForm />
              </RoleBasedGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: "legacy-migration",
        children: [
          {
            element: (
              <RoleBasedGuard
                permissionBased={false}
                permissions={[ENTERPRISE_ROLES.admin]}
              >
                <LegacyMigrationLinkedRegister />
              </RoleBasedGuard>
            ),
            index: true,
          },
        ],
      },
    ],
  },
];
